"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

var _ = require("../");

var _overflowmenu = _interopRequireDefault(require("../overflowmenu"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
// TODO: BUG: set value via prop & change select value. both selected value and placeholder appear

/*---------------------------------------------*/
var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);

  var _super = _createSuper(Select);

  function Select() {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this);
    _this.state = {
      comboInputValue: null
    }; // We need to create a new key each time the native select value is changed,
    // otherwise an invalid selection may remain on the select element.
    // Example - select valueX, change the props.value to be invalid, then select valueX again.
    // Both the select value and the placeholder will be displayed.

    _this.selectVersion = 0;
    _this.onSelect = _this.onSelect.bind(_assertThisInitialized(_this));
    _this.onNativeSelect = _this.onNativeSelect.bind(_assertThisInitialized(_this));
    _this.onComboInputChange = _this.onComboInputChange.bind(_assertThisInitialized(_this));
    _this.onMenuToggle = _this.onMenuToggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Select, [{
    key: "onSelect",
    value: function onSelect(index, value) {
      this.setState({
        index: index,
        comboInputValue: null
      });
      this.props.onChange && this.props.onChange(value, this.props.name);
    }
  }, {
    key: "onNativeSelect",
    value: function onNativeSelect(e) {
      this.selectVersion++;
      this.onSelect(1 * e.target.value, this.props.children[1 * e.target.value].props.value);
    }
  }, {
    key: "onComboInputChange",
    value: function onComboInputChange(value) {
      this.setState({
        comboInputValue: value
      }); // this.props.onChange && this.props.onChange
    }
  }, {
    key: "onMenuToggle",
    value: function onMenuToggle(isOpen) {
      this.setState({
        isMenuOpen: isOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      this.addClass("".concat(this.constructor.BASE_CLASS, "--").concat(this.props.size || "normal"));
      var iconType = this.state.isMenuOpen ? "ChevronUp" : "ChevronDown";

      var icon = /*#__PURE__*/_react.default.createElement(_.Icon, {
        className: this.constructor.BASE_CLASS + "__icon",
        size: 20,
        icon: iconType,
        color: "var(--select-input-arrow-color)"
      });

      var options = _react.default.Children.map(this.props.children, function (item, _index) {
        return /*#__PURE__*/_react.default.cloneElement(item, {
          onClick: item.props.onClick || _this2.props.onItemClick
        });
      });

      var isControlled = typeof this.props.value !== "undefined" && this.props.value !== "";
      var index = isControlled ? options.findIndex(function (option) {
        return option.props.value === _this2.props.value;
      }) : this.state.index;
      var hasValue = index >= 0;
      var placeholderText = this.props.placeholder || "Choose Option";

      var placeholder = /*#__PURE__*/_react.default.createElement("span", {
        className: this.constructor.BASE_CLASS + "__input__placeholder"
      }, placeholderText);

      var control = function (type) {
        if (type === "native") {
          var selectOptions = options.map(function (option, idx) {
            return /*#__PURE__*/_react.default.createElement("option", {
              value: idx,
              key: idx,
              selected: index === idx
            }, option.props.label);
          });
          return /*#__PURE__*/_react.default.createElement("div", {
            className: _this2.constructor.BASE_CLASS + "__container"
          }, /*#__PURE__*/_react.default.createElement("select", {
            className: _this2.constructor.BASE_CLASS + "__input",
            onChange: _this2.onNativeSelect,
            tabIndex: 0,
            key: _this2.selectVersion
          }, /*#__PURE__*/_react.default.createElement("option", {
            disabled: hasValue,
            hidden: hasValue,
            style: {
              display: "none"
            },
            selected: !hasValue,
            value: ""
          }), selectOptions), hasValue ? null : placeholder, icon);
        }

        var valueText = hasValue ? options[index].props.label || options[index].props.children : undefined;

        var input = function () {
          if (type === "combo") {
            return /*#__PURE__*/_react.default.createElement(_.Input, {
              value: _this2.state.comboInputValue || valueText,
              onChange: _this2.onComboInputChange,
              placeholder: placeholderText
            });
          }

          var value = hasValue ? /*#__PURE__*/_react.default.createElement("span", {
            className: _this2.constructor.BASE_CLASS + "__input__value"
          }, valueText) : placeholder;
          var textColor = hasValue ? "--color-neutal-90" : "--color-neutral-500";
          return /*#__PURE__*/_react.default.createElement("div", {
            className: _this2.constructor.BASE_CLASS + "__input " + _this2.constructor.BASE_CLASS + "__container",
            tabIndex: 0
          }, /*#__PURE__*/_react.default.createElement(_.Text, {
            color: textColor
          }, value), icon);
        }();

        return /*#__PURE__*/_react.default.createElement(_overflowmenu.default, {
          onMenuToggle: _this2.onMenuToggle,
          onItemClick: _this2.onSelect,
          target: input,
          fullwidth: _this2.props.fullwidth
        }, options);
      }(this.props.type || "custom");

      var label = this.props.label ? /*#__PURE__*/_react.default.createElement(_.Label, {
        disabled: this.props.disabled
      }, this.props.label) : null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassNames(),
        style: this.getStyle(),
        ref: this.ref
      }, label, control);
    }
  }]);

  return Select;
}(_component.default);
/*----*/


exports.default = Select;

_defineProperty(Select, "BASE_CLASS", "lth-c-select");

Select.Option = function (props) {
  return /*#__PURE__*/_react.default.createElement(_overflowmenu.default.Item, props);
};

Select.Option.METADATA = _objectSpread(_objectSpread({}, _overflowmenu.default.Item.METADATA), {}, {
  name: "Select.Option"
});

Select.Separator = function (props) {
  return /*#__PURE__*/_react.default.createElement(_overflowmenu.default.Separator, props);
};

Select.Separator.METADATA = {
  name: "Select.Separator"
};
/*----*/

Select.METADATA = {
  name: "Select",
  description: "",
  props: [{
    name: "label",
    type: "string",
    default: "Choose an option"
  }, {
    name: "value",
    type: "string",
    description: "Selected value"
  }, {
    name: "placeholder",
    type: "string"
  }, {
    name: "options",
    type: "string",
    description: "Options to select from"
  }, {
    name: "type",
    type: "string",
    default: "custom",
    options: [{
      value: "custom"
    }, {
      value: "native"
    }, {
      value: "combo"
    }]
  }, {
    name: "size",
    type: "string",
    default: "regular",
    description: "Choose the size",
    options: [{
      value: "slim"
    }, {
      value: "regular"
    }, {
      value: "super"
    }]
  }, {
    name: "onChange",
    type: "function",
    description: "Callback function called when the value was changed"
  }, {
    name: "disabled",
    type: "boolean",
    default: false
  }, {
    name: "forcehover",
    type: "boolean",
    default: false
  }, {
    name: "forcefocus",
    type: "boolean",
    default: false
  }],
  content: {
    default: [/*#__PURE__*/_react.default.createElement(Select.Option, {
      label: "Option 1",
      value: "value1"
    }), /*#__PURE__*/_react.default.createElement(Select.Option, {
      label: "Option 2",
      value: "value2"
    }), /*#__PURE__*/_react.default.createElement(Select.Option, {
      label: "Option 3",
      value: "value3"
    })]
  }
};